import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../services/toast.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const toast = inject(ToastService);
  
  if (auth.isAdmin()) return true;
  
  toast.error('No tienes permisos para acceder a este módulo');
  return router.createUrlTree(['/dashboard']);
};
